import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  static values = {
    userIds: Array
  }

  selectedIds = []

  initialize() {
    this.handleSelectionChange = this.handleSelectionChange.bind(this)
    this.updateButtonDisabledState = this.updateButtonDisabledState.bind(this)
  }

  connect() {
    this.selectedIds = this.userIdsValue || []
    document.addEventListener("tableSelection:change", this.handleSelectionChange)
    addEventListener("turbo:frame-load", this.updateButtonDisabledState)
    this.updateButtonDisabledState()
  }

  disconnect() {
    document.removeEventListener("tableSelection:change", this.handleSelectionChange)
    removeEventListener("turbo:frame-load", this.updateButtonDisabledState)
  }

  handleSelectionChange(event) {
    this.selectedIds = event.detail.selectedIds
    this.updateButtonDisabledState()
  }

  updateButtonDisabledState() {
    this.buttonTargets.forEach(button => {
      if (button.dataset.openDrawerFixedIdsParam) return

      button.classList.toggle("disabled", !this.selectedIds.length)
    })
  }
}
